import React from 'react';
import { Text } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { Counter } from 'src/components/Counter';
import Plus from 'src/assets/icons/plus.svg';
import Settings from 'src/assets/icons/settings.svg';
import Bell from 'src/assets/icons/bell.svg';
import User from 'src/assets/icons/user.svg';
import {
  PanelHeader,
  PanelHeaderButton,
  PanelHeaderBack,
  PanelHeaderClose,
} from 'src/components/PanelHeader';

storiesOf('PanelHeader', module).add('Default', () => (
  <React.Fragment>
    <PanelHeader
      left={<PanelHeaderBack />}
      right={
        <React.Fragment>
          <PanelHeaderButton label={<Counter variant="prominent">1</Counter>}>
            <Bell />
          </PanelHeaderButton>
          <PanelHeaderButton>
            <User />
          </PanelHeaderButton>
        </React.Fragment>
      }
    >
      🎛 Panel Header
    </PanelHeader>
    <PanelHeader>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quidem, quis.
    </PanelHeader>
    <PanelHeader
      left={
        <PanelHeaderButton rounded={false}>
          <Text>Cancel</Text>
        </PanelHeaderButton>
      }
      right={
        <PanelHeaderButton>
          <Plus />
        </PanelHeaderButton>
      }
    >
      Panel Header
    </PanelHeader>
    <PanelHeader
      left={
        <PanelHeaderButton rounded={false}>
          <Text>Cancel</Text>
        </PanelHeaderButton>
      }
      right={
        <React.Fragment>
          <PanelHeaderButton>
            <Plus />
          </PanelHeaderButton>
        </React.Fragment>
      }
    >
      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia, sequi.
    </PanelHeader>
    <PanelHeader
      left={
        <PanelHeaderButton rounded={false}>
          <Text>Cancel</Text>
        </PanelHeaderButton>
      }
      right={
        <React.Fragment>
          <PanelHeaderButton label={<Counter variant="prominent">3</Counter>}>
            <Bell />
          </PanelHeaderButton>
          <PanelHeaderButton label={<Counter variant="prominent">3</Counter>}>
            <Settings />
          </PanelHeaderButton>
        </React.Fragment>
      }
    >
      Panel Header
    </PanelHeader>
    <PanelHeader left={<PanelHeaderClose>Close</PanelHeaderClose>}>Panel Header</PanelHeader>
  </React.Fragment>
));
